import PageHead from './PageHead';
import { useTranslation } from '../contexts/LanguageContext';
import { PAGE_META } from '../i18n/pageMeta';

// Title, description and robots for `path` from PAGE_META, in the active language.
function PageMeta({ path }) {
    const { t } = useTranslation();
    const { title, description, robots } = PAGE_META[path](t);
    return (
        <PageHead>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            <meta property="og:title" content={title} />
            {robots && <meta name="robots" content={robots} />}
        </PageHead>
    );
}

export default PageMeta;
